import React, { useMemo } from 'react'
import Recommendations from './Recommendations/Recommendations'
import RecentlyViewedCarousel from './RecentlyViewedCarousel';
import { getRecommendationConfig } from './RecommendationMiddleware'; // Import middleware
import { useShoppingCartContext } from '../ShoppingCartV2/providers/ShoppingCartProvider';
import { usef40flag } from '../../hooks/constructor';
import { useFeatureFlags } from '@usap/core';
import CartRecoSkeletonLoader from '@usap/uicomponents/src/components/loaders/CartRecoSkeletonLoader';
import { StaticPropsProvider } from '../../contexts/staticProps.context';

export default function RecommendationWidget(props){
    const { apiDetails, originalDynamicApiData } = props
    const { pageType = '', orderDetails = {} } = originalDynamicApiData || {}
    const { cartData } = useShoppingCartContext()

    // const decisions = useFeatureFlags()
    // const isFlagEnabled = useMemo(() => usef40flag(decisions), [decisions])
    // if (!isFlagEnabled) return null
  

    if(!pageType || !Object.keys(apiDetails).length){
        console.error("pageType or apiDetails are missing")
        return <></>
    }

    const currentConfig = apiDetails?.find(item => item.pageType === pageType);
    const pageRecommendationsSettings = currentConfig?.recommendationSettings;
    const staticProps = currentConfig?.props;

    if(!pageRecommendationsSettings || !Array.isArray(pageRecommendationsSettings) || pageRecommendationsSettings.length < 1){
        console.error(`recommendationSettings is not configured for page: ${pageType}`)
        return <></>
    }

    if (pageType === 'cart' && cartData?.initial) return <CartRecoSkeletonLoader />;

   return (

    <StaticPropsProvider value={staticProps}>
        <div>
            {pageRecommendationsSettings.map((recommendationSetting,index)=>{
                if(recommendationSetting?.strategy === "RecentlyViewed" && recommendationSetting.enable) {
                    return (<RecentlyViewedCarousel 
                                key={index} 
                                label={recommendationSetting?.label}  
                                widgetName={recommendationSetting?.strategy || recommendationSetting?.strategy} 
                            />)
                }
                const recommendationUrl = getRecommendationConfig(recommendationSetting, orderDetails, cartData)
                return (recommendationSetting.enable && recommendationUrl &&
                    <Recommendations 
                        key={index} 
                        label={recommendationSetting?.label || recommendationSetting?.strategy} 
                        widgetName={recommendationSetting?.strategy} 
                        recommendationUrl={recommendationUrl}
                        showAddToCart={recommendationSetting?.showAddToCart}
                        showGuaranteedToFit={recommendationSetting?.showGuaranteedToFit}
                        recommendationData={recommendationSetting}
                        lastRecord={pageRecommendationsSettings.length === index+1}
                    />)
            })}
        </div>
        </StaticPropsProvider>
    )
}